module.exports = __webpack_public_path__ + "media/images/crypto-currencies/bitcoin-78be76cdc30dc2be10c7f1065191e196.svg";